export const gauthOption = {
  clientId: process.env.VUE_APP_GOOGLE_ID,
  scope: 'profile email',
  prompt: 'select_account'
}